import { Plugin, PluginListenerHandle, registerPlugin } from '@capacitor/core'

const FacebookEventsPlugin = registerPlugin<FacebookEventsPlugin>(
  'FacebookEventsPlugin',
  {
    web: () => new WebFacebookEventsPlugin(),
  }
)
export default FacebookEventsPlugin

export interface FacebookEventsPlugin extends Plugin {
  logEvent(options: {
    eventName: string
    parameters?: { [key: string]: any }
  }): Promise<void>
}

// this is just for tests, a real web implemention of FacebookEventPlugin is not needed
export class WebFacebookEventsPlugin implements FacebookEventsPlugin {
  logEvent(options: {
    eventName: string
    parameters?: { [key: string]: any }
  }): Promise<void> {
    return undefined
  }

  addListener(
    eventName: string,
    listenerFunc: (...args: any[]) => any
  ): Promise<PluginListenerHandle> {
    return undefined
  }

  removeAllListeners(): Promise<void> {
    return undefined
  }
}
